// Typed amounts to integer cents and back, and typed percentages to basis points and back, by their digits — never by
// multiplying or dividing (CLAUDE.md: only `packages/money` does arithmetic on money). `R 2 450.00`, `2450` and `2450.5` are
// 245 000, 245 000 and 245 050 cents; `5` and `12.5` per cent are 500 and 1 250 basis points.

const AMOUNT = /^(\d{1,9})(?:[.,](\d{0,2}))?$/;

/** A rand amount as typed — an optional `R`, spaces as thousands separators, up to two decimals — in cents; null when it is not one. */
export function centsFromText(text: string): number | null {
  const s = text.trim().replace(/^R\s*/i, "").replace(/[\s ]/g, "");
  const m = AMOUNT.exec(s);
  if (!m) return null;
  return Number(`${m[1]}${(m[2] ?? "").padEnd(2, "0")}`);
}

/** Cents as an input's text, `2450.00`; empty for none. */
export function textFromCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || !Number.isInteger(cents) || cents < 0) return "";
  const s = String(cents).padStart(3, "0");
  return `${s.slice(0, -2)}.${s.slice(-2)}`;
}

// Up to four whole digits: a markup may be 1 000% (100 000 basis points, BR-PRICING-004's cap); the API holds each field to its own range.
const PERCENT = /^(\d{1,4})(?:[.,](\d{0,2}))?$/;

/** A percentage as typed, up to two decimals, in basis points (`12.5` → 1 250); null when it is not one. */
export function bpFromPercentText(text: string): number | null {
  const m = PERCENT.exec(text.trim().replace(/%$/, "").trim());
  if (!m) return null;
  return Number(`${m[1]}${(m[2] ?? "").padEnd(2, "0")}`);
}

/** Basis points as an input's text, without trailing zeros: 500 → `5`, 1 250 → `12.5`. */
export function percentTextFromBp(bp: number | null | undefined): string {
  if (bp === null || bp === undefined || !Number.isInteger(bp) || bp < 0) return "";
  const s = String(bp).padStart(3, "0");
  const frac = s.slice(-2).replace(/0+$/, "");
  return frac ? `${Number(s.slice(0, -2))}.${frac}` : String(Number(s.slice(0, -2)));
}
